<template>
  <div>
    <v-sheet elevation="1">
      <v-toolbar dense color="white">
        <v-toolbar-title>{{ screenTitle }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" persistent>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-if="!listFlag"
              v-on="on"
              class="mx-2"
              color="primary"
              >「新規登録」はこのボタンを押してください</v-btn
            >
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{
                $formTitle("クロノロジー情報", isDetailView, isNew)
              }}</span>
            </v-card-title>
            <v-card-text>
              <validation-observer ref="observer">
                <v-form ref="updForm">
                  <v-container>
                    <v-alert
                      dense
                      outlined
                      type="error"
                      v-if="errorCheckSaveDialog"
                    >
                      {{ errorCheckSaveDialog }}
                    </v-alert>
                    <datetime-picker
                      :title="'報告日時'"
                      :isClearWhenInit="true"
                      :datetime="editedItem.create_at"
                      :selectedDatetime.sync="editedItem.create_at"
                      :disabled="editedItem.read_only"
                      :validation="true"
                    />
                    <v-row>
                      <v-col cols="7">
                        <v-select
                          v-model="editedItem.disaster_no"
                          :items="disasterItems"
                          :placeholder="
                            editedItem.read_only
                              ? config.PLACEHOLDER_SP
                              : config.PLACEHOLDER_SELECT
                          "
                          :rules="[$validation.rules.required]"
                          label="災害名称"
                          item-text="disaster_name"
                          item-value="disaster_no"
                          v-bind="formControlProps()"
                        >
                        </v-select>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6" md="4" lg="3">
                        <v-select
                          v-model="editedItem.info_type"
                          :items="kinds"
                          :placeholder="
                            editedItem.read_only
                              ? config.PLACEHOLDER_SP
                              : config.PLACEHOLDER_SELECT
                          "
                          label="種別"
                          item-text="kind_name"
                          item-value="kind_id"
                          v-bind="formControlProps()"
                        >
                        </v-select>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6">
                        <v-select
                          v-model="editedItem.municip_code"
                          :items="municipalities"
                          :placeholder="
                            editedItem.read_only
                              ? config.PLACEHOLDER_SP
                              : config.PLACEHOLDER_SELECT
                          "
                          label="市町村"
                          item-text="municip_name"
                          item-value="municip_code"
                          @change="changeEditMunicipCode"
                          v-bind="formControlProps()"
                        >
                        </v-select>
                      </v-col>
                      <v-col cols="6">
                        <v-select
                          v-model="editedItem.area_code"
                          :items="editAreas"
                          :placeholder="
                            editedItem.read_only
                              ? config.PLACEHOLDER_SP
                              : config.PLACEHOLDER_SELECT
                          "
                          label="地域（地区）"
                          @change="changeEditAreaCode"
                          v-bind="formControlProps()"
                        >
                        </v-select>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-select
                          v-model="editedItem.fa_id"
                          :items="editFacilities"
                          :placeholder="
                            editedItem.read_only
                              ? config.PLACEHOLDER_SP
                              : config.PLACEHOLDER_SELECT
                          "
                          label="避難所"
                          v-bind="formControlProps()"
                        >
                        </v-select>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="12" md="12" lg="12">
                        <v-textarea
                          v-model="editedItem.regist_body"
                          :placeholder="
                            editedItem.read_only
                              ? config.PLACEHOLDER_SP
                              : config.PLACEHOLDER_INPUT
                          "
                          label="内容"
                          v-bind="formControlProps(500)"
                          :readonly="editedItem.read_only"
                          :clearable="false"
                          rows="8"
                        >
                        </v-textarea>
                      </v-col>
                    </v-row>
                    <p
                      v-if="editedItem.read_only"
                      style="white-space:pre-wrap;"
                    >
                      {{ sampleMessages }}
                    </p>
                    <v-row>
                      <v-col cols="12" sm="6" md="6" lg="6">
                        <validation-observer
                          ref="fileUploadObserver"
                          v-slot="fileUploadObserverProps"
                        >
                          <v-dialog v-model="uploadDialog" persistent>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="mx-2 ml-0"
                                color="primary"
                                small
                                @click="setEditedFileItems"
                                >{{
                                  editedItem.read_only
                                    ? "ファイルの参照"
                                    : "ファイルの添付"
                                }}</v-btn
                              >
                              <v-tooltip
                                right
                                :open-on-hover="false"
                                color="grey lighten-4"
                              >
                                <template v-slot:activator="{ on }">
                                  <v-btn
                                    icon
                                    @click="on.click"
                                    @blur="on.blur"
                                    retain-focus-on-click
                                  >
                                    <v-icon>mdi-help-circle-outline</v-icon>
                                  </v-btn>
                                </template>
                                <span style="color: black">
                                  最大10個の添付ファイルが登録可能。<br />
                                  ファイルサイズの合計が20Mバイト以内であること。<br />
                                  以下の拡張子であること。<br />
                                  .png、.gif、.jpeg、.jpg、.txt、.pdf、.doc、.docx、.xls、.xlsx、.ppt、.pptx<br />
                                  動画ファイルはアップロード不可<br />
                                </span>
                              </v-tooltip>
                            </template>
                            <v-card>
                              <v-card-title></v-card-title>
                              <v-card-text>
                                <v-toolbar dense color="white">
                                  <v-toolbar-title>
                                    ファイル添付
                                    <span
                                      v-if="!editedItem.read_only"
                                      class="ml-3 caption"
                                    >
                                      ※元の画面の{{
                                        saveBtnText
                                      }}ボタンにより、システムに登録されます。
                                    </span>
                                  </v-toolbar-title>
                                  <v-spacer></v-spacer>
                                  <v-btn
                                    class="mx-2"
                                    color="primary"
                                    :disabled="
                                      disabledAddFile ||
                                        !fileUploadObserverProps.valid
                                    "
                                    v-if="!editedItem.read_only"
                                    @click="addFile"
                                    >添付ファイルの追加</v-btn
                                  >
                                </v-toolbar>
                                <v-alert
                                  style="margin-top: 16px"
                                  dense
                                  outlined
                                  type="error"
                                  v-if="errorCheckFileUpload"
                                >
                                  {{ errorCheckFileUpload }}
                                </v-alert>
                                <v-data-table
                                  v-model="selectedFiles"
                                  :headers="filesHeaders"
                                  :items="editedFileItems"
                                  :show-select="!editedItem.read_only"
                                  class="elevation-1 mt-2"
                                  locale="ja-jp"
                                  item-key="file_no"
                                  no-data-text="データはありません。"
                                  hide-default-footer
                                >
                                  <template v-slot:[`item.file`]="{ item }">
                                    <validation-provider
                                      v-slot="{ errors }"
                                      rules="required|validExtensions"
                                    >
                                      <v-file-input
                                        v-model="item.file"
                                        :placeholder="config.PLACEHOLDER_FILE"
                                        :accept="config.FILE_INPUT_ACCEPT"
                                        :error-messages="errors"
                                        prepend-icon="mdi-paperclip"
                                        class="mt-2"
                                        dense
                                        v-bind="formControlProps()"
                                        @change="changeFile(item)"
                                      >
                                        <template v-slot:selection="{ text }">
                                          <v-chip
                                            v-if="!editedItem.read_only"
                                            small
                                            label
                                            color="primary"
                                          >
                                            {{ text }}
                                          </v-chip>
                                          <div v-else class="list-file-name">
                                            {{ text }}
                                          </div>
                                        </template>
                                      </v-file-input>
                                    </validation-provider>
                                  </template>
                                  <template v-slot:[`item.remarks`]="{ item }">
                                    <v-text-field
                                      v-model="item.remarks"
                                      :placeholder="config.PLACEHOLDER_INPUT"
                                      class="mt-2"
                                      dense
                                      v-bind="formControlProps(30)"
                                    >
                                    </v-text-field>
                                  </template>
                                  <template v-slot:[`item.delete`]="{ item }">
                                    <v-btn
                                      v-model="item.delete"
                                      color="primary"
                                      small
                                      @click="removeFile(item)"
                                      v-if="!editedItem.read_only"
                                    >
                                      削除
                                    </v-btn>
                                  </template>
                                </v-data-table>
                              </v-card-text>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  class="mx-2"
                                  color="primary"
                                  @click="setFiles"
                                  v-if="!editedItem.read_only"
                                  :disabled="
                                    !fileUploadObserverProps.valid ||
                                      errorCheckFileUpload !== ''
                                  "
                                >
                                  設定
                                </v-btn>
                                <v-btn
                                  class="mx-2"
                                  color="primary"
                                  @click="removeAllFiles"
                                  v-if="!editedItem.read_only"
                                  :disabled="disabledRemoveAllFiles"
                                >
                                  一括削除
                                </v-btn>
                                <v-btn
                                  class="mx-2"
                                  color="primary"
                                  @click="uploadDialog = false"
                                >
                                  {{ $cancelButtonText(editedItem.read_only) }}
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </validation-observer>
                      </v-col>
                    </v-row>
                    <file-list
                      :items="editedItem.attach_files"
                      :display="displayFileList"
                    />
                  </v-container>
                </v-form>
              </validation-observer>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                class="mx-2"
                color="primary"
                @click="save"
                v-if="!editedItem.read_only"
                :disabled="validateSave()"
              >
                {{ saveBtnText }}
              </v-btn>
              <v-btn class="mx-2" color="primary" @click="dialog = false">
                {{ $cancelButtonText(editedItem.read_only) }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <v-container fluid>
        <error-message :error-object="errorObject" />
        <success-message :success-object="successObject" />
        <p style="margin: 5px 0 15px 0">
          クロノロジー情報は下の表を参照してください。条件を指定することで一覧から絞り込むことができます。<br />
          最新の情報が最大2,000件表示されます。
        </p>
        <v-alert dense outlined type="error" v-if="errorCheck">
          {{ errorCheck }}
        </v-alert>
        <datetime-picker
          :title="'報告日時（開始）'"
          :datetime="createAtFromFilterValue"
          :selectedDatetime.sync="createAtFromFilterValue"
        />
        <datetime-picker
          :title="'報告日時（終了）'"
          :datetime="createAtToFilterValue"
          :selectedDatetime.sync="createAtToFilterValue"
          :is-to="true"
          :is-search="true"
        />
        <v-row>
          <v-col cols="6" md="3">
            <v-select
              v-model="disasterNameFilterValue"
              :placeholder="config.PLACEHOLDER_SELECT"
              :items="[
                {
                  disaster_no: '999999',
                  disaster_name: '災害名称なし（情報投稿）'
                },
                {
                  disaster_no: '999998',
                  disaster_name: '災害名称なし（情報投稿以外）'
                },
                ...disasters
              ]"
              label="災害名称"
              item-text="disaster_name"
              item-value="disaster_no"
              clearable
              outlined
              @change="setTableItem(false)"
            >
            </v-select>
          </v-col>
          <v-col cols="6" md="3">
            <v-select
              v-model="registeredUserFilterValue"
              :items="registeredUsers"
              :placeholder="config.PLACEHOLDER_SELECT"
              label="登録者"
              clearable
              outlined
              @change="setTableItem(false)"
            >
            </v-select>
          </v-col>
          <v-col cols="6" md="3">
            <v-select
              v-model="kindFilterValue"
              :items="kinds"
              :placeholder="config.PLACEHOLDER_SELECT"
              label="種別"
              item-text="kind_name"
              item-value="kind_id"
              clearable
              outlined
              @change="setTableItem(false)"
            >
            </v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10">
            <div class="sub-guide">
              「市町村」「地域（地区）」「避難所」の検索は、クロノロジー情報一覧から登録・編集された情報のみ絞り込むことができます。
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-select
              v-model="municipCodeFilterValue"
              :items="municipalities"
              :placeholder="config.PLACEHOLDER_SELECT"
              label="市町村"
              item-text="municip_name"
              item-value="municip_code"
              clearable
              outlined
              @change="changeMunicipCode"
            >
            </v-select>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-select
              v-model="areaCodeFilterValue"
              :items="areas"
              :placeholder="config.PLACEHOLDER_SELECT"
              label="地域（地区）"
              clearable
              outlined
              @change="changeAreaCode"
            >
            </v-select>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-select
              v-model="faIdFilterValue"
              :items="facilities"
              :placeholder="config.PLACEHOLDER_SELECT"
              label="避難所"
              clearable
              outlined
              @change="setTableItem(false)"
            >
            </v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="contentFilterValue"
              :placeholder="config.PLACEHOLDER_INPUT"
              label="内容"
              append-icon="mdi-magnify"
              hide-details
              clearable
              outlined
              @change="setTableItem(false)"
            >
            </v-text-field>
          </v-col>
          <v-col>
            <v-btn color="primary" v-on:click="beforeRegistSerach"
              >災害名称登録前の情報投稿</v-btn
            >
          </v-col>
        </v-row>
        <v-row v-if="!listFlag">
          <v-col>
            <v-btn color="primary" v-on:click="downloadCSV">ダウンロード</v-btn>
          </v-col>
        </v-row>
        <v-divider class="mb-1" />
        <v-row>
          <v-col>
            <top-operation-data-table
              disp-mode="nowrap"
              :headers="headers"
              :items="convertItems"
              :sort-by="sort.by"
              ref="chronologyTable"
              class="fixedWidth"
              locale="ja-jp"
              sort-desc
              must-sort
            >
              <template v-slot:[`item.create_at`]="{ item }">
                {{ formatDatetime(item.create_at) }}
              </template>
              <template v-slot:[`item.registrant_type`]="{ item }">
                {{ registeredUserName(item) }}
              </template>
              <template v-slot:[`item.info_type`]="{ item }">
                {{ kindName(item) }}
              </template>
              <template v-slot:[`item.regist_body`]="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span
                      v-bind="attrs"
                      v-on="on"
                      class="d-inline-block text-truncate"
                      style="max-width: 720px"
                    >
                      {{ item.regist_body }}
                    </span>
                  </template>
                  <span>{{ item.regist_body }}</span>
                </v-tooltip>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <template v-if="!hasUpdateAuthorityByItem(item, listFlag)">
                  <v-btn
                    small
                    class="mx-2"
                    color="primary"
                    @click="editItem(item)"
                  >
                    参照
                  </v-btn>
                </template>
                <template v-else>
                  <v-btn
                    small
                    class="mx-2"
                    color="primary"
                    @click="editItem(item)"
                    v-if="hasUpdateAuthorityByItem(item)"
                  >
                    編集
                  </v-btn>
                  <v-btn
                    small
                    class="mx-2"
                    color="primary"
                    @click="deleteConfirm(item)"
                    v-if="hasDeleteAuthorityByItem(item, !hasDeleteAuthority)"
                  >
                    削除
                  </v-btn>
                  <v-btn
                    small
                    class="mx-2"
                    color="primary"
                    @click="editItem(item, true)"
                  >
                    参照
                  </v-btn>
                </template>
              </template>
            </top-operation-data-table>
          </v-col>
        </v-row>
      </v-container>
      <confirm-dialog ref="confirmOpenEdit" />
      <v-dialog v-model="deleteDialog" persistent max-width="400">
        <v-card>
          <v-card-title></v-card-title>
          <v-card-text>
            <v-form ref="deleteForm">
              <p>削除した場合には元に戻せません。本当によろしいですか？</p>
              <v-textarea
                v-model="reason"
                :placeholder="config.PLACEHOLDER_INPUT"
                :rules="[$validation.rules.required]"
                label="削除理由"
                outlined
                v-bind="formControlProps(100)"
                :clearable="false"
              ></v-textarea></v-form
          ></v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              class="mx-2"
              color="primary"
              @click="deleteItem"
              :disabled="validateDelete()"
            >
              削除
            </v-btn>
            <v-btn class="mx-2" color="primary" @click="deleteDialog = false">
              キャンセル
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-overlay
        :value="overlay"
        opacity="1"
        color="white"
        z-index="2147483647"
      >
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-sheet>
  </div>
</template>

<script>
import Vue from "vue";
import cloneDeep from "lodash/cloneDeep";
import messageUtils from "@/mixins/message-utils";
import Disaster from "@/plugins/disaster";
import FormUtils from "@/plugins/form-utils";
import Validation from "@/plugins/validation";
import config from "@/js/const";
import { fileDownload, makeRandom } from "@/js/utils";
import { RepositoryFactory } from "@/js/repository/RepositoryFactory";
import { AllAreaTranslator } from "@/js/translators/allAreaTranslator";
import { DisasterTranslator } from "@/js/translators/disasterTranslator";
import { ScreenId } from "@/js/value-objects/screen-id";
import { required } from "vee-validate/dist/rules";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode
} from "vee-validate";

setInteractionMode("eager");
extend("required", {
  ...required,
  message: "必須項目です。"
});

Vue.use(Disaster);
Vue.use(FormUtils);
Vue.use(Validation);

const allAreaRepository = RepositoryFactory.get("allArea");
const chronologyRepository = RepositoryFactory.get("chronologies");
const disasterInfoRepository = RepositoryFactory.get("disasterInfo");
const facilityRepository = RepositoryFactory.get("facilities");
const fileS3UploadRepository = RepositoryFactory.get("fileS3Upload");
const systemInfoRepository = RepositoryFactory.get("systemInfo");

const SAMPLE_MESSAGE =
  "位置を地図サービスで調べる場合は、緯度と経度をカンマ" +
  "「,」区切りで入力し、検索してください。\n" +
  "　例）緯度：12.345678  経度：176.543210の場合 \n" +
  "　　「12.345678, 176.543210」";

/**
 * ファイル添付のベース情報
 */
const DEFAULT_FILES = [
  {
    file_no: 1, // ファイル連番
    file_name: "", // ファイル名
    remarks: "", // 備考
    s3object: makeRandom(6), // S3オブジェクト
    file: null, // ファイルオブジェクト
    fileUploadFlag: true // true：ファイルアップロードを実施
  }
];

const REGISTERED_USERS = [
  {
    text: "システム（システム）",
    value: "SYS"
  },
  {
    text: "システム（ユーザ）",
    value: "SYU"
  },
  {
    text: "防災関係者",
    value: "DPP"
  },
  {
    text: "ユーザ",
    value: "USR"
  },
  {
    text: "その他",
    value: "OTH"
  }
];

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    ConfirmDialog: () => import("@/components/ConfirmDialog"),
    DatetimePicker: () => import("@/components/DatetimePicker"),
    FileList: () => import("@/components/chronology/FileList"),
    ErrorMessage: () => import("@/components/ErrorMessage"),
    SuccessMessage: () => import("@/components/SuccessMessage"),
    TopOperationDataTable: () => import("@/components/ui/TopOperationDataTable")
  },

  mixins: [messageUtils],

  data: () => ({
    screenId: ScreenId.SF0406,
    overlay: false,
    dialog: false,
    deleteDialog: false,
    deleteFlag: false,
    tempItem: {},
    uploadDialog: false,
    listFlag: false,
    isDetailView: false, // 詳細画面表示判定 true：詳細画面／false：編集画面
    displayFileList: false,
    config: config,
    municipalities: [],
    baseAreas: [],
    editAreas: [],
    areas: [],
    baseFacilities: [],
    editFacilities: [],
    facilities: [],
    reason: "",
    items: [],
    editedIndex: -1, // 編集中アイテムのインデックス（新規登録の場合は-1）
    /**
     * 編集中アイテム情報
     */
    editedItem: {
      chronology_seq: null, // クロノロジー連番
      create_at: null, // 報告日時
      regist_date: null, // 登録日
      disaster_no: null, // 災害番号
      registrant: null, // 登録者
      registrant_type: null, // 登録種別
      info_type: null, // 情報種別
      municip_code: null,
      area_code: null,
      fa_id: null,
      chronology_id: null, // クロノロジーID
      chronology_pid: null, // 親クロノロジーID
      regist_body: null, // 登録内容
      gps_lat: null, // GPS緯度
      gps_long: null, // GPS経度
      attach_id: null, // クロノロジー添付ID
      attach_files: cloneDeep(DEFAULT_FILES), // 添付ファイル情報
      authcheck: null, // 権限コード,
      read_only: false // 参照のみか
    },
    /**
     * 新規アイテムのベース情報
     */
    defaultItem: {
      chronology_seq: null, // クロノロジー連番
      create_at: null, // 報告日時
      regist_date: null, // 登録日
      disaster_no: null, // 災害番号
      registrant: null, // 登録者
      registrant_type: null, // 登録種別
      info_type: null, // 情報種別
      municip_code: null,
      area_code: null,
      fa_id: null,
      chronology_id: null, // クロノロジーID
      chronology_pid: null, // 親クロノロジーID
      regist_body: null, // 登録内容
      gps_lat: null, // GPS緯度
      gps_long: null, // GPS経度
      attach_id: null, // クロノロジー添付ID
      attach_files: cloneDeep(DEFAULT_FILES), // 添付ファイル情報
      authcheck: null, // 権限コード,
      read_only: false // 参照のみか
    },
    editedFileItems: [],
    disasters: [],
    unendedDisasters: [],
    registeredUsers: REGISTERED_USERS, // 登録者プルダウンの選択肢
    kinds: [], // 種別リスト
    category: "CHRONOLOGY_TYPE",
    createAtFromFilterValue: "",
    createAtToFilterValue: "",
    disasterNameFilterValue: "",
    registeredUserFilterValue: "",
    kindFilterValue: "",
    contentFilterValue: "",
    municipCodeFilterValue: "",
    areaCodeFilterValue: "",
    faIdFilterValue: "",
    selectedFiles: [], // 添付ファイルダイアログの選択ファイル情報
    disasterItems: [], // 新規登録・編集ダイアログの災害名称プルダウンの選択肢
    screenTitle: "",
    hasDeleteAuthority: false,
    sampleMessages: SAMPLE_MESSAGE
  }),

  computed: {
    /**
     * データテーブルのヘッダー定義
     */
    headers() {
      return [
        {
          text: "報告日時",
          value: "create_at"
        },
        {
          text: "登録者",
          value: "registrant_type"
        },
        {
          text: "種別",
          value: "info_type",
          sort: this.KindSorter,
          sortable: true
        },
        {
          text: "内容",
          value: "regist_body"
        },
        {
          text: "操作",
          value: "actions",
          sortable: false
        }
      ];
    },

    /**
     * 新規登録・更新を判断する
     */
    isNew() {
      return this.editedIndex === -1;
    },

    /**
     * 新規登録・編集ダイアログのボタンテキスト
     */
    saveBtnText() {
      return this.isNew ? "登録" : "更新";
    },

    /**
     * 添付ファイルダイアログのテーブルヘッダー定義
     */
    filesHeaders() {
      const filesHeaders = [
        {
          text: "ID",
          align: " d-none",
          value: "file_no",
          sortable: false
        },
        {
          text: "ファイル",
          value: "file",
          sortable: false
        },
        {
          text: "備考",
          value: "remarks",
          sortable: false
        },
        {
          text: "削除",
          value: "delete",
          sortable: false
        }
      ];
      if (this.listFlag) {
        // クロノロジー情報一覧画面の場合は削除ボタンを表示しない
        return filesHeaders.filter(item => item.value !== "delete");
      }
      return filesHeaders;
    },

    /**
     * 添付ファイルダイアログ（「添付ファイルの追加」の活性条件）
     */
    disabledAddFile() {
      return this.editedFileItems.length > 9;
    },

    /**
     * 添付ファイルダイアログ（「一括削除」の活性条件）
     */
    disabledRemoveAllFiles() {
      return this.selectedFiles.length < 1;
    },

    /**
     * フォームのプロパティ制御
     */
    formControlProps: () => {
      return function(counter = null) {
        return this.$formControlProps(this.editedItem.read_only, counter);
      };
    },

    /**
     * 取得データの変換
     * 災害名称なし（情報投稿以外）はDBでは空データに該当する。
     * プルダウンに空を設定すると未入力とみなされるため必須エラーとなり、編集不可となるため
     * 画面では999998のコードで保持する
     */
    convertItems() {
      let convertItems = this.items;
      convertItems.forEach(obj => {
        if (obj.disaster_no === "") {
          obj.disaster_no = "999998";
        }
      });
      return convertItems;
    },

    /**
     * エラーチェック（クロノロジー情報一覧）
     */
    errorCheck() {
      // 未来日時チェック
      // YYYY-MM-DD HH:mm:00形式
      let createAtFrom, createAtTo;
      const nowTime = this.$moment();
      if (this.createAtFromFilterValue) {
        createAtFrom = this.$moment(
          this.createAtFromFilterValue,
          "YYYY-MM-DD HH:mm:00"
        );
        if (createAtFrom.isAfter(nowTime)) {
          return "日付が未来日時のためエラーです。";
        }
      }
      if (this.createAtToFilterValue) {
        createAtTo = this.$moment(
          this.createAtToFilterValue,
          "YYYY-MM-DD HH:mm:00"
        );
        if (createAtTo.isAfter(nowTime)) {
          return "日付が未来日時のためエラーです。";
        }
      }
      // 報告日時の前後チェック
      if (createAtFrom && createAtTo) {
        if (createAtTo.isBefore(createAtFrom)) {
          return "終了報告日時が開始報告日時より前の日時です。";
        }
      }
      return "";
    },

    /**
     * エラーチェック（登録・更新ダイアログ）
     */
    errorCheckSaveDialog() {
      // クロノロジー情報一覧の場合はreturn
      if (this.listFlag) {
        return "";
      }
      // 未来日時チェック
      //YYYY-MM-DD HH:mm:00形式
      let createAt;
      const nowTime = this.$moment();
      if (this.editedItem.create_at) {
        createAt = this.$moment(
          this.editedItem.create_at,
          "YYYY-MM-DD HH:mm:00"
        );
        if (createAt.isAfter(nowTime)) {
          return "日付が未来日時のためエラーです。";
        }
      }
      return "";
    },

    /**
     * エラーチェック（ファイル添付ダイアログ）
     */
    errorCheckFileUpload() {
      // アップロードファイル容量チェック
      let fileSize = 0; // 合計ファイルサイズ（単位B）
      const LIMIT_SIZE = 20; // 限界値（単位MB）
      const MEGA = 1048576; // 1MB（1048576B）
      for (const item of this.editedFileItems) {
        if (item.file) {
          fileSize += item.file.size;
        }
      }
      if (fileSize > LIMIT_SIZE * MEGA) {
        return "アップロードファイル容量が20Mバイトを超えています。";
      }
      return "";
    },
    sort() {
      return {
        by: ["create_at"]
      };
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    uploadDialog(val) {
      val || this.closeUpload();
    },
    createAtFromFilterValue() {
      this.setTableItem(false);
    },
    createAtToFilterValue() {
      this.setTableItem(false);
    },
    $route: "initialize"
  },

  mounted() {
    this.pageTitle(this.screenTitle);
  },

  created() {
    this.initialize();
  },

  methods: {
    /**
     * 初期化処理
     */
    async initialize() {
      this.overlay = true;

      const screen = this.$screenOperationAuthority(
        ScreenId.SF0402,
        ScreenId.SF0406
      );
      this.listFlag = screen.readOnly;
      this.screenId = screen.screenId;
      this.screenTitle = screen.screenTitle;
      this.hasDeleteAuthority = screen.hasDeleteAuthority;

      await Promise.all([
        // 災害配信情報
        disasterInfoRepository.list(this.screenId),
        // 災害配信情報(未終結)
        disasterInfoRepository.unfinished(this.screenId),
        // 全地域検索
        allAreaRepository.getAllArea(),
        // 施設情報参照
        facilityRepository.getFacility(null, null, ["1"], this.screenId),
        // システム情報参照
        systemInfoRepository.list(this.screenId, this.category)
      ])
        .then(values => {
          // 災害名称セレクトボックス候補設定（クロノロジー情報一覧用）
          this.disasters = DisasterTranslator.sortByDisasterNo(
            values[0].data.results,
            true
          );
          this.disasterNameFilterValue = this.$disaster.disaster_no;
          // 災害名称セレクトボックス候補設定（登録・更新ダイアログ用）
          this.unendedDisasters = DisasterTranslator.sortByDisasterNo(
            values[1].data.results,
            true
          );
          this.disasterItems = cloneDeep(this.unendedDisasters);
          // 市町村一覧
          this.municipalities = values[2].data.results[0].municipalities.filter(
            m => m.disp_flg !== "1"
          );
          // 地域一覧
          this.baseAreas = AllAreaTranslator.toAreas(values[2].data);
          // 避難所一覧
          const shelterList = values[3].data.results[0]["1"];
          let emergencyShelter = shelterList["designatedEmergencyShelter"].map(
            shelter => ({
              value: shelter.fa_id,
              text: shelter.fa_name,
              eva_area_info: shelter.eva_area_info
            })
          );
          let designatedShelter = shelterList["designatedShelter"].map(
            shelter => ({
              value: shelter.fa_id,
              text: shelter.fa_name,
              eva_area_info: shelter.eva_area_info
            })
          );
          let temporaryShelter = shelterList["temporaryShelter"].map(
            shelter => ({
              value: shelter.fa_id,
              text: shelter.fa_name,
              eva_area_info: shelter.eva_area_info
            })
          );
          // 施設ID, 施設名, 市町村コード, 地域コードのみに絞り込み
          this.baseFacilities = emergencyShelter.concat(
            designatedShelter,
            temporaryShelter
          );
          // 種別（システム情報）一覧
          const systemVals = values[4].data.results;
          this.kinds = systemVals.map(systemVal => {
            const pushItem = {
              kind_id: systemVal.value,
              kind_name: systemVal.value2
            };
            return pushItem;
          });
        })
        .catch(e => {
          this.handleError(e, this.screenId, "aggregation-menu");
        });

      // 新規登録ダイアログの災害名称セレクトボックスの初期値としてトップで選択した災害の災害番号を設定
      this.editedItem.disaster_no = this.$disaster.disaster_no;
      this.defaultItem.disaster_no = this.$disaster.disaster_no;

      // 詳細画面表示初期化
      this.isDetailView = this.listFlag;

      // テーブルアイテムを設定
      await this.setTableItem();
      this.overlay = false;
    },

    /**
     * 添付ファイル変更時処理
     * @param {*} item 編集中アイテム
     */
    changeFile(item) {
      let targetItem = this.editedFileItems.find(
        file => file.file_no === item.file_no
      );
      if (targetItem) {
        // ファイル名を設定
        targetItem.file_name = targetItem.file.name;
        if (!targetItem.fileUploadFlag) {
          // ファイルアップロードフラグが設定されていない場合は、S3オブジェクトとフラグを設定
          targetItem.s3object = makeRandom(6);
          targetItem.fileUploadFlag = true;
        }
      }
    },
    /**
     * 添付ファイルアイテム設定
     */
    setEditedFileItems() {
      // 添付ファイルアイテム設定
      this.editedFileItems = cloneDeep(this.editedItem.attach_files);
      // ファイルNoの振り直し
      this.resetFileNo();
      // ファイル情報一覧を非表示
      this.displayFileList = false;
    },

    /**
     * CSVダウンロード処理
     */
    downloadCSV() {
      let csv = "\ufeff";

      // ヘッダー
      const headers = {
        chronology_seq: "クロノロジー連番",
        create_at: "報告日時",
        registrant: "登録者",
        registrant_type: "登録種別",
        info_type: "情報種別",
        chronology_id: "クロノロジーID",
        chronology_pid: "親クロノロジーID",
        regist_body: "登録内容"
      };
      csv += Object.values(headers).join(",") + "\n";

      // Body（本文）
      this.items.forEach(item => {
        const itemList = Object.keys(headers)
          .filter(header => item[header] !== undefined)
          .map(header => {
            let pushItem = item[header];
            if (header === "registrant_type") {
              const data = this.registeredUsers.find(
                obj => obj.value === pushItem
              );
              if (data) {
                pushItem = data.text;
              } else {
                pushItem = "";
              }
            } else if (header === "info_type") {
              const data = this.kinds.find(obj => obj.kind_id == pushItem);
              if (data) {
                pushItem = data.kind_name;
              } else {
                pushItem = "";
              }
            } else if (header === "create_at") {
              if (pushItem) {
                pushItem = this.$moment(pushItem, "YYYY-MM-DD HH:mm").format(
                  "YYYY年MM月DD日HH時mm分"
                );
              } else {
                pushItem = "";
              }
            } else if (header === "regist_body") {
              if (pushItem) {
                pushItem = pushItem.replace(/\n/g, "　");
              } else {
                pushItem = "";
              }
            }
            return pushItem;
          });
        if (itemList.length > 0) {
          csv += itemList.join(",") + "\n";
        }
      });
      let blob = new Blob([csv], { type: "text/csv" });
      fileDownload(blob, "CHRONOLOGY_INFO.csv");
    },

    /**
     * テーブルアイテム設定
     * @param {*} limitFlag 件数制限フラグ（2000件を超える場合にエラーレスポンスを返却したい場合にfalseを設定）
     */
    async setTableItem(limitFlag = true) {
      // 検索項目にエラーがある場合は、検索を実行しない
      if (this.errorCheck) {
        return;
      }

      this.overlay = true;

      // クロノロジー情報
      let payload = {
        limit_flg: limitFlag
      };
      // 報告日時（開始）
      if (this.createAtFromFilterValue) {
        payload.create_at_from = this.$moment(
          this.createAtFromFilterValue
        ).format("YYYY-MM-DD HH:mm:00");
      }
      // 報告日時（終了）
      if (this.createAtToFilterValue) {
        payload.create_at_to = this.$moment(this.createAtToFilterValue).format(
          "YYYY-MM-DD HH:mm:00"
        );
      }
      // 災害番号（v-modelがオブジェクト型の為、項目名まで指定している）
      if (this.disasterNameFilterValue) {
        if (this.disasterNameFilterValue === "999998") {
          payload.disaster_no = "";
        } else {
          payload.disaster_no = this.disasterNameFilterValue;
        }
      }
      // 登録者
      if (this.registeredUserFilterValue) {
        payload.registrant_type = this.registeredUserFilterValue;
      }
      // 情報種別
      if (this.kindFilterValue) {
        payload.info_type = this.kindFilterValue;
      }
      // 内容
      if (this.contentFilterValue) {
        payload.regist_body = this.contentFilterValue;
      }
      // 市町村コード
      if (this.municipCodeFilterValue) {
        payload.municip_code = this.municipCodeFilterValue;
      }
      // 地域コード
      if (this.areaCodeFilterValue) {
        payload.area_code = this.areaCodeFilterValue;
      }
      // 施設ID
      if (this.faIdFilterValue) {
        payload.fa_id = this.faIdFilterValue;
      }
      // エラーメッセージの表示・非表示分岐
      // 検索条件を変更した場合、現在のメッセージを削除
      if (!limitFlag) {
        this.clearMessage();
      }
      // クロノロジー情報取得
      await chronologyRepository
        .list(this.screenId, payload)
        .then(response => {
          this.items = response.data.results;
          if (this.$refs.chronologyTable) {
            this.$refs.chronologyTable.resetPage();
          }
        })
        .catch(e => {
          if (e.response.data.error.code == "ERAE40007") {
            // 検索結果が2000件を超えた場合
            this.handleGetError(e);
          } else {
            this.handleError(e, this.screenId, "aggregation-menu");
          }
        });

      // ファイル操作
      this.items.forEach(item => {
        if (item.attach_files && item.attach_files.length > 0) {
          for (let file of item.attach_files) {
            // ファイル名表示用の空ファイルを作成
            file.file = new File([], file.file_name);
          }
        } else {
          if (!this.listFlag) {
            item.attach_files = cloneDeep(DEFAULT_FILES);
          }
        }
      });
      this.overlay = false;
    },

    /**
     * ダイアログの市町村コード変更時処理
     */
    changeEditMunicipCode() {
      // ダイアログの地域を絞り込み
      this.editAreas = this.baseAreas.filter(
        area => area.municipality === this.editedItem.municip_code
      );
      // 地域・避難所情報を初期化
      this.editedItem.area_code = null;
      this.editedItem.fa_id = null;
      this.editFacilities = [];
    },

    /**
     * ダイアログの地域コード変更時処理
     */
    changeEditAreaCode() {
      // ダイアログの避難所を絞り込み
      this.editFacilities = this.baseFacilities.filter(facility =>
        facility.eva_area_info.some(
          evaAreaInfo => evaAreaInfo.eva_area_code === this.editedItem.area_code
        )
      );
      // 避難所情報を初期化
      this.editedItem.fa_id = null;
    },

    /**
     * 検索項目の市町村コード変更時処理
     */
    changeMunicipCode() {
      // 検索項目の地域を絞り込み
      this.areas = this.baseAreas.filter(
        area => area.municipality === this.municipCodeFilterValue
      );
      // 地域・避難所情報を初期化
      this.areaCodeFilterValue = null;
      this.faIdFilterValue = null;
      this.facilities = [];
      // クロノロジー取得API実行
      this.setTableItem(false);
    },

    /**
     * 検索項目の地域コード変更時処理
     */
    changeAreaCode() {
      // 検索項目の避難所を絞り込み
      this.facilities = this.baseFacilities.filter(facility =>
        facility.eva_area_info.some(
          evaAreaInfo => evaAreaInfo.eva_area_code === this.areaCodeFilterValue
        )
      );
      // 避難所情報を初期化
      this.faIdFilterValue = null;
      // クロノロジー取得API実行
      this.setTableItem(false);
    },

    /**
     * データテーブル表示用（報告日時）
     */
    formatDatetime(datetime) {
      const formattedDatetime = this.$moment(datetime);
      if (formattedDatetime.isValid()) {
        return formattedDatetime.format("YYYY/MM/DD HH:mm");
      }
      return "";
    },

    /**
     * データテーブル表示用（登録者）
     */
    registeredUserName(item) {
      const data = this.registeredUsers.find(
        obj => obj.value === item.registrant_type
      );
      if (data) {
        return data.text;
      }
      return "－";
    },

    /**
     * データテーブル表示用（災害名称）
     */
    disasterName(item) {
      const data = this.disasters.find(
        obj => obj.disaster_no === item.disaster_no
      );
      if (data) {
        return data.disaster_name;
      }
      return "";
    },

    /**
     * データテーブル表示用（種別）
     */
    kindName(item) {
      const data = this.kinds.find(obj => obj.kind_id === item.info_type);
      if (data) {
        return data.kind_name;
      }
      return "";
    },

    /**
     * 災害名称登録前の情報投稿ボタン押下時処理
     */
    async beforeRegistSerach() {
      this.overlay = true;
      // 最新の災害名称取得
      this.clearMessage();
      await disasterInfoRepository
        .latest(this.screenId)
        .then(disasters => {
          // 最新の災害名称の新規登録日時を取得
          const disasterDate = new Date(disasters.data.results[0].created_date);
          const createdDate = this.$moment(disasterDate);
          const disasterToDateValue = createdDate.format("YYYY-MM-DD HH:mm:ss");
          // 24時間前の日時を設定
          const disasterFromDateValue = createdDate
            .add(-1, "days")
            .format("YYYY-MM-DD HH:mm:ss");

          // 報告日時(開始)に最新の災害名称登録日時の24時間前の日時を設定
          this.createAtFromFilterValue = disasterFromDateValue;

          // 報告日時(終了)に最新の災害名称登録日時を設定
          this.createAtToFilterValue = disasterToDateValue;

          // 災害名称に「災害名称なし」を設定
          // 災害番号999999のデータを選択
          this.disasterNameFilterValue = "999999";

          // クロノロジー取得APIを実行し一覧に表示する
          this.setTableItem(false);
        })
        .catch(e => {
          this.handleGetError(e);
        });
      this.overlay = false;
    },

    /**
     * 参照・編集ボタン押下時処理
     */
    async editItem(item, readOnlyFlag = false) {
      if (!readOnlyFlag) {
        this.isDetailView = this.listFlag;
      } else {
        // 一覧（登録・編集・削除）の参照ボタン押下時は詳細表示
        this.isDetailView = true;
      }
      if (this.hasUpdateAuthorityByItem(item, this.isDetailView)) {
        // 編集確認ダイアログ表示
        const result = await this.$refs.confirmOpenEdit.open(
          "編集すると情報は更新されず、追加されます。",
          "編集"
        );
        if (!result) {
          return false;
        }
      }
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      // 編集ダイアログ設定
      // 災害名称セレクトボックスの候補設定
      const editedDisasterNo = this.editedItem.disaster_no;
      if (editedDisasterNo === "999999") {
        // 参照・編集は災害名称のセレクトボックスの候補に「災害名称なし（情報投稿）」を追加する
        this.disasterItems.unshift({
          disaster_no: "999999",
          disaster_name: "災害名称なし（情報投稿）"
        });
      }
      if (editedDisasterNo === "999998") {
        // 参照・編集は災害名称のセレクトボックスの候補に「災害名称なし（情報投稿以外）」を追加する
        this.disasterItems.unshift({
          disaster_no: "999998",
          disaster_name: "災害名称なし（情報投稿以外）"
        });
      }
      if (editedDisasterNo) {
        // 編集アイテムの災害情報を選択候補に追加
        const isExist = this.disasterItems.some(
          item => item.disaster_no === editedDisasterNo
        );
        if (!isExist) {
          const disasterItem = this.disasters.find(
            disaster => disaster.disaster_no === editedDisasterNo
          );
          if (disasterItem) {
            this.disasterItems.push(disasterItem);
          }
        }
      }
      this.editedItem.read_only = !this.hasUpdateAuthorityByItem(
        item,
        this.isDetailView
      );

      const editedMunicipCode = this.editedItem.municip_code;
      this.editAreas = [];
      this.editFacilities = [];
      if (editedMunicipCode) {
        // 地域セレクトボックスの候補設定
        // 市町村コードがある場合、地域を絞り込み
        this.editAreas = this.baseAreas.filter(
          area => area.municipality === editedMunicipCode
        );
        const editedAreaCode = this.editedItem.area_code;
        if (editedAreaCode) {
          // 地域セレクトボックスに地域コードが含まれない場合は追加
          const isAreaExist = this.editAreas.some(
            area => area.value === editedAreaCode
          );
          if (!isAreaExist) {
            const editAreaInfo = this.baseAreas.find(
              area => area.value === editedAreaCode
            );
            if (editAreaInfo) {
              this.editAreas.push(editAreaInfo);
            }
          }

          // 組織セレクトボックスの候補設定
          // 避難所を絞り込み
          this.editFacilities = this.baseFacilities.filter(facility =>
            facility.eva_area_info.some(
              evaAreaInfo =>
                evaAreaInfo.eva_area_code === this.editedItem.area_code
            )
          );
          const editedFaId = this.editedItem.fa_id;
          if (editedFaId) {
            // 地域セレクトボックスに地域コードが含まれない場合は追加
            const isFaExist = this.editFacilities.some(
              facility => facility.value === editedFaId
            );
            if (!isFaExist) {
              const editFaInfo = this.baseFacilities.find(
                facility => facility.value === editedFaId
              );
              if (editFaInfo) {
                this.editFacilities.push(editFaInfo);
              }
            }
          }
        }
      }
      this.displayFileList = true;
      this.dialog = true;
    },

    /**
     * 削除バリデーションチェック処理
     */
    validateDelete() {
      // 必須チェック
      return !this.reason;
    },

    /**
     * 削除ボタン押下時処理
     */
    async deleteItem() {
      // 削除理由設定
      this.tempItem.reason = this.reason;
      // 削除処理
      this.clearMessage();
      const payload = this.toDeletePayload(this.tempItem);
      await chronologyRepository
        .delete(this.screenId, payload)
        .then(response => {
          this.handleSuccess(response);
        })
        .catch(e => {
          this.handleUpdateError(e);
        })
        .finally(() => {
          this.initialize();
        });
      this.deleteDialog = false;
    },

    /**
     * 削除用リクエストボディ作成
     */
    toDeletePayload(editedItem) {
      return {
        chronology_seq: editedItem.chronology_seq, // 必須項目
        regist_date: editedItem.regist_date, // 必須項目
        disaster_no:
          editedItem.disaster_no === "999998" ? "" : editedItem.disaster_no,
        registrant: editedItem.registrant,
        chronology_id: editedItem.chronology_id,
        chronology_pid: editedItem.chronology_pid,
        reason: editedItem.reason,
        gps_lat: editedItem.gps_lat,
        gps_long: editedItem.gps_long,
        delete_flg: "1" // 必須項目
      };
    },

    /**
     * 削除ボタン押下時処理
     * 削除確認ダイアログ表示
     */
    deleteConfirm(item) {
      this.tempItem = item;
      if (this.$refs.deleteForm) {
        this.$refs.deleteForm.resetValidation();
      }
      this.reason = "";
      this.deleteDialog = true;
    },

    /**
     * 新規登録・編集ダイアログ（クローズ処理）
     */
    close() {
      this.$refs.observer.reset();
      this.isDetailView = this.listFlag;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.disasterItems = cloneDeep(this.unendedDisasters);
      });
    },

    /**
     * ファイル添付ダイアログ（設定）
     */
    setFiles() {
      const hasFiles = this.editedFileItems.some(file => file.file);
      if (!hasFiles) {
        // 添付ファイルが存在しない場合
        this.editedItem.attach_files = cloneDeep(DEFAULT_FILES);
      } else {
        // 添付ファイルが存在する場合
        this.editedItem.attach_files = this.editedFileItems;
      }
      this.uploadDialog = false;
    },

    /**
     * ファイル添付ダイアログ（一括削除）
     */
    removeAllFiles() {
      if (this.selectedFiles) {
        for (let i = 0; i < this.selectedFiles.length; i++) {
          const index = this.editedFileItems.indexOf(this.selectedFiles[i]);
          this.editedFileItems.splice(index, 1);
        }
      }
      this.selectedFiles = [];

      // ファイルNoの振り直し
      this.resetFileNo();
    },

    /**
     * ファイル添付ダイアログ（添付ファイルの追加）
     */
    addFile() {
      const fileNo = this.editedFileItems.length;
      this.editedFileItems.push({
        file_no: fileNo,
        file_name: "",
        remarks: "",
        s3object: makeRandom(6),
        file: null,
        fileUploadFlag: true // true：ファイルアップロードを実施
      });
    },

    /**
     * ファイル添付ダイアログ（削除）
     */
    removeFile(item) {
      // アイテム削除
      const index = this.editedFileItems.indexOf(item);
      this.editedFileItems.splice(index, 1);
      // ファイルNoの振り直し
      this.resetFileNo();
    },

    /**
     * ファイル添付ダイアログ（クローズ処理）
     */
    closeUpload() {
      this.displayFileList = true;
      this.$nextTick(() => {
        this.selectedFiles = [];
        this.editedFileItems = [];
      });
    },

    /**
     * ファイルNoの採番処理
     */
    resetFileNo() {
      let fileNo = 0;
      for (const fileItem of this.editedFileItems) {
        fileItem.file_no = fileNo;
        fileNo++;
      }
    },

    /**
     * 登録・更新バリデーションチェック処理
     */
    validateSave() {
      // 必須チェック
      if (!this.editedItem.disaster_no) {
        return true;
      }
      //未来日時チェック
      if (!this.editedItem.create_at) {
        return true;
      }
      return false;
    },

    /**
     * 登録・更新処理
     */
    async save() {
      // 添付ファイル
      // ファイル情報が存在しない場合はリストから除外
      this.editedItem.attach_files = this.editedItem.attach_files.filter(
        file => file.file
      );

      // editedIndexが-1の場合は新規登録、それ以外は編集
      const isUpdate = this.editedIndex > -1;
      let payload = this.toPayload(cloneDeep(this.editedItem), isUpdate);
      // 災害名称なし（情報投稿以外）が選択されている場合はキーを設定しない
      if (payload.disaster_no === "999998") {
        this.$delete(payload, "disaster_no");
      }

      this.overlay = true;
      if (isUpdate) {
        this.clearMessage();
        // 更新処理
        const resUpdate = await chronologyRepository
          .update(ScreenId.SF0403, payload)
          .catch(e => {
            this.handleUpdateError(e);
            return "ERROR";
          });
        // ファイルアップロード処理
        if (resUpdate !== "ERROR") {
          // アップロード対象ファイルが存在する
          if (this.editedItem.attach_files.length > 0) {
            const resUpdateFileUpload = await this.fileUpload(ScreenId.SF0403);
            if (resUpdateFileUpload !== "ERROR") {
              this.handleSuccess(resUpdate);
            }
          } else {
            // アップロードするファイルなし
            this.handleSuccess(resUpdate);
          }
        }
        this.dialog = false;
        this.overlay = false;
        this.initialize();
      } else {
        this.clearMessage();
        // 登録処理
        const resCreate = await chronologyRepository
          .create(ScreenId.SF0404, payload)
          .catch(e => {
            this.handleUpdateError(e);
            return "ERROR";
          });
        // ファイルアップロード処理
        if (resCreate !== "ERROR") {
          // アップロード対象ファイルが存在する
          if (this.editedItem.attach_files.length > 0) {
            const resCreateFileUpload = await this.fileUpload(ScreenId.SF0404);
            if (resCreateFileUpload !== "ERROR") {
              this.handleSuccess(resCreate);
            }
          } else {
            // アップロードするファイルなし
            this.handleSuccess(resCreate);
          }
        }
        this.dialog = false;
        this.overlay = false;
        this.initialize();
      }
    },

    /**
     * 登録・更新API用ペイロード作成
     * @param {*} editedItem 対象アイテム
     * @param {*} isUpdate 更新フラグ（true：更新処理、false：新規登録処理）
     */
    toPayload(editedItem, isUpdate) {
      // 報告日時を設定（形式：YYYY-MM-DD HH:mm:00）
      const createdDate = this.$moment(editedItem.create_at).format(
        "YYYY-MM-DD HH:mm:00"
      );
      // 添付ファイル情報からファイル情報を削除
      const attachFiles = editedItem.attach_files.map(item => ({
        file_no: item.file_no, // ファイル連番
        file_name: item.file_name, // ファイル名
        remarks: item.remarks, // 備考
        s3object: item.s3object // S3オブジェクト
      }));

      if (isUpdate) {
        // 編集の場合
        return {
          chronology_seq: editedItem.chronology_seq,
          regist_date: editedItem.regist_date,
          disaster_no: editedItem.disaster_no,
          registrant: null, // API側で設定
          registrant_type: "DPP", // Web画面では「DPP」固定
          info_type: editedItem.info_type,
          chronology_pid: editedItem.chronology_id, // 編集アイテムのクロノロジーIDを設定
          regist_body: editedItem.regist_body,
          gps_lat: editedItem.gps_lat,
          gps_long: editedItem.gps_long,
          attach_id: null,
          municip_code: editedItem.municip_code,
          area_code: editedItem.area_code,
          fa_id: editedItem.fa_id,
          created_date: createdDate,
          attach_files: attachFiles
        };
      } else {
        // 新規登録の場合
        return {
          disaster_no: editedItem.disaster_no,
          registrant: null, // API側で設定
          registrant_type: "DPP", // Web画面では「DPP」固定
          info_type: editedItem.info_type,
          regist_body: editedItem.regist_body,
          gps_lat: editedItem.gps_lat,
          gps_long: editedItem.gps_long,
          attach_id: null,
          municip_code: editedItem.municip_code,
          area_code: editedItem.area_code,
          fa_id: editedItem.fa_id,
          created_date: createdDate,
          attach_files: attachFiles
        };
      }
    },

    /**
     * ファイルアップロード処理
     * @param {*} screenId 画面ID
     */
    async fileUpload(screenId) {
      return Promise.all(
        this.editedItem.attach_files
          // ファイルアップロードフラグがtrueのアイテムのみを対象にする
          .filter(file => file.fileUploadFlag)
          .map(async attachFile => {
            // バイナリデータ読み込み＆ファイルアップロードAPI呼び出し
            await this.uploadFiles(attachFile, screenId);
          })
      ).catch(e => {
        this.handleUpdateError(e);
        return "ERROR";
      });
    },

    /**
     * アップロードファイルリスト作成＆アップロードAPIへ渡す
     * @param {*} file ファイル
     */
    async uploadFiles(attachFile, screenId) {
      await new Promise(resolve => {
        let reader = new FileReader();
        reader.readAsDataURL(attachFile.file);
        reader.addEventListener("load", e => {
          attachFile.file.binary = e.target.result.replace(
            /data:.*\/.*;base64,/,
            ""
          );
          resolve();
        });
      }).then(async () => {
        // ファイルアップロードAPI呼び出し
        let s3object = null;
        if (attachFile.file) {
          const splits = attachFile.file.name.split(".");
          s3object = attachFile.s3object + "." + splits[splits.length - 1];
        }
        await fileS3UploadRepository.create(
          screenId,
          s3object,
          process.env.VUE_APP_BUCKET_NAME_BOUSAI,
          attachFile.file.binary
        );
      });
    },

    /**
     * カスタムソーター（種別）
     */
    KindSorter(a, b) {
      return a.localeCompare(b);
    }
  }
};
</script>
<style scoped>
.list-file-name {
  color: black;
}
</style>
